import type { components } from '@/types/openapi';

export type LogSourcesDialogMode = 'EditLogSources' | 'AddLogSources';

export type LogSourcesResponseDTO = components['schemas']['LogSourcesResponse'];
export type ConnectionInputSchemaDTO =
  components['schemas']['ConnectionInputSchema'];
export type DataStreamDTO = components['schemas']['DataStream'];
export type LogSourceDTO = components['schemas']['LogSource'];
export type LogSourceConfigDTO = components['schemas']['LogSourceConfig'];
export type UserAction =
  | 'user-selected'
  | 'user-deselected'
  | 'auto-populated'
  | 'unchanged';

export type DataStreamModel = DataStreamDTO & {
  display_name?: string;
  isSelected?: boolean;
  selectionSource?: UserAction;
};

export type LogSourceModel = LogSourceDTO & {
  isSelected: boolean;
  configuration?: string;
  streamsPartlySelected: boolean;
  display_name?: string;
  timeZone?: string;
  selectionSource?: UserAction;
  data_streams?: DataStreamModel[];
  doc_link?: string;
};

export type LogSourceProps = {
  row: LogSourceModel;
};

export type LogSourcesPayload = {
  sources: string[];
  source_configs: { [key: string]: object };
  input_configs: { [key: string]: object };
};

// Constants for HTTP status codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201
} as const;
